import React, { ChangeEventHandler, Dispatch, SetStateAction, useState } from 'react';
import { InputText } from 'components/_new/InputText';
import { Checkbox } from 'primereact/checkbox';

type LinkFormData = {
	url: string;
	openInNewTab: boolean;
};

const defaultFormData: LinkFormData = { url: '', openInNewTab: false };

export const useEditLinkForm = (
	initialValue?: LinkFormData
): [[LinkFormData, Dispatch<SetStateAction<LinkFormData>>], () => void] => {
	const [state, setState] = useState<LinkFormData>(initialValue || defaultFormData);
	const reset = () => {
		setState(initialValue || defaultFormData);
	};
	return [[state, setState], reset];
};

type LinkEditFormProps = {
	formState: [LinkFormData, Dispatch<SetStateAction<LinkFormData>>];
};

export const LinkEditForm = ({ formState }: LinkEditFormProps) => {
	const [{ url, openInNewTab }, setFormData] = formState;

	const handleUrlChange: ChangeEventHandler = ({ currentTarget }) => {
		if (currentTarget && currentTarget instanceof HTMLInputElement) {
			setFormData((prev) => ({ ...prev, url: currentTarget.value }));
		}
	};

	return (
		<div className="flex flex-column gap-2">
			<InputText placeholder="https://...." slim value={url} onChange={handleUrlChange} />
			<div className="flex flex-row gap-2 align-items-center text-sm">
				<Checkbox
					checked={openInNewTab}
					onChange={({ checked }) => setFormData((prev) => ({ ...prev, openInNewTab: checked }))}
				/>
				<span>Otwórz w nowej karcie</span>
			</div>
		</div>
	);
};
